import React from 'react';
import AppRouter from './routing/AppRouter';
import { useBranding } from './hooks/useBranding';

function App() {
  useBranding();
  return <AppRouter />;
}

export default App;
